import { useEffect, useRef, useState } from 'react';
import './LoginCSS.css'
import { useNavigate, Link, useLocation } from 'react-router-dom'
import { LoadingButton } from '@mui/lab';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Cookies } from 'react-cookie';
import Loader from './Loader';
import config from '../../EnvConfig/env_config';


const cookies = new Cookies();

export default function SignIn() {
    const StaticToken = config.secret_key;
    const source = 'web'
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false)
    const [user, setUser] = useState({ userCode: '', password: '' });
    let [state, setState] = useState(false);

    const inputRefs = useRef([]);

    const handleLogin = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        const data = {
            Token: StaticToken,
            UserCode: user.userCode !== '' ? user.userCode : '0',
            Password: user.password,
            Source: source
        }

        await fetch('/api/UserLogin/Login', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            },
        }).then(async (response) => {
            const res = await response.json();
            if (res.status === 'SUCCESS') {
                await cookies.set('token', res.token);
                await cookies.set('loginUserCode', res.loginUserCode);
                await cookies.set('userName', res.userName);
                setTimeout(() => {
                    setIsLoading(false);
                    navigate(location.state || '/dashboard')
                    localStorage.setItem('ID', "1")
                }, 2000)
            } else {
                setState(false);
                setIsLoading(false);
                toast.error(res.message, {
                    position: 'top-center'
                })
                inputRefs.current[res.focus].focus()
            }
        }).catch((err) => {
            setState(false);
            setIsLoading(false);
            toast.error(err, {
                position: 'top-center'
            })
        })
    };
    const handleDownloadClick = () => {
        const apkUrl = 'http://mega.sagarinfotech.com/TrackMate.apk';
        const link = document.createElement('a');
        link.href = apkUrl;
        link.download = 'TrackMate.apk';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

   

    useEffect(() => {
        inputRefs.current['txtUserCode'].focus();
    }, [])

    return (
        <>
            <div className="container-fluid bg-login vh-100 d-flex justify-content-center align-items-center" >
                <div className="row" data-aos="zoom-in" data-aos-duration="1000" >
                    <div className="col-sm-3 px-4 py-5 main-login text-black rounded">
                        <div className=''>
                            {/*<img src="./assets/img/logo.png" className='img1' alt="..." />*/}
                            <img src="./assets/img/LoginTrackmate-logo.png" className='img1' alt="" />
                        </div>
                        <div className="">
                            <form method='POST' >
                                <h5 className=" fs-4 my-2 text-center" style={{ textShadow: '2px 2px 2px var(--mycolorFilterCheckText)' }}> Welcome To
                                    TrackMate
                                </h5>
                                <div className="col-lg-3 col-md-4 col-sm-6" style={{ width: '100%' }}>
                                    <div className="fields">
                                        <label className="form-label">User Code</label>
                                        <input
                                            ref={ref => (inputRefs.current['txtUserCode'] = ref)}
                                            type="text"
                                            className="form-control"
                                            autoComplete="off"
                                            name='userCode'
                                            placeholder='User Code'
                                            maxLength='9'
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    inputRefs.current['txtPassword'].focus();
                                                };

                                            }
                                            }
                                            value={user.userCode}
                                            onChange={(e) => {
                                                let { value } = e.target
                                                const userCode = value.replace(/[^0-9]/g, '')
                                                setUser({ ...user, userCode: userCode })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-6" style={{ width: '100%' }}>
                                    <div className="fields">
                                        <label className="form-label">Password</label>
                                        <input
                                            ref={ref => (inputRefs.current['txtPassword'] = ref)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    handleLogin(e)
                                                };
                                            }}
                                            type="password"
                                            className="form-control"
                                            autoComplete="off"
                                            placeholder='Password'
                                            maxLength='20'
                                            name='Password'
                                            value={user.password}
                                            onChange={(e) => setUser({ ...user, password: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="py-2 loading">
                                    <LoadingButton loading={state} disabled={isLoading} style={{ background: "var(--mycolorFilterCheckText)" }} loadingPosition='center' onClick={handleLogin} className=' py-1' variant="contained"> Login </LoadingButton>
                                    {isLoading && (<Loader text='AUTHENTICATING' size='100px' img_path='./assets/img/giphy.gif' />)}
                                   {/* &nbsp;&nbsp;&nbsp;<LoadingButton style={{ background: "var(--mycolorFilterCheckText)" }} loadingPosition='center' onClick={handleDownloadClick} className=' py-1' variant="contained"> Download APK </LoadingButton>*/}

                                    {/*&nbsp;&nbsp;&nbsp;*/}
                                    {/*<Link onClick={() => handleDownloadClick()}  className="text-light" style={{ fontSize: "14px", color: 'white', }}>*/}
                                    {/*    <u>Download APK</u>*/}
                                    {/*</Link>*/}
                                </div>

                                <Link to={'/forgetpassword'} className="text-light" style={{ fontSize: "14px" }}>
                                    Forgot password?
                                </Link>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer theme='colored' />
        </>
    );
}





